module.exports = __webpack_public_path__ + "static/media/react_and_redux2.284fe22e.md";